import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { encryptionHostLive } from "@/api/php/user"; 
import { uitlsToLiveRoom, YMPush } from "@/uitls/uitls";
import { cheackQuery, nativeToNewWeb, ToBack } from "@/uitls/native";
import { useI18n } from 'vue-i18n'

export default /*#__PURE__*/_defineComponent({
  name: 'History',
  setup(__props, { expose }) {
  expose();

const { t } = useI18n()
const route = useRoute();
const router = useRouter();
let data = ref([]);

// const livetj = require(`@/assets/${process.env.VUE_APP_NAME}/home-match-rec.png`)
const livezb = require(`@/assets/${process.env.VUE_APP_NAME}/live-gif.gif`)  

onMounted(() => {
  cheackQuery(route);
  getdata();
  YMPush('MAIN', 'HistoryDialog')
});
const getdata = async () => {
  const res: any = await encryptionHostLive();
  if (res.code == 200) {
    data.value = res.data;
    console.log(data.value);
  }
};
function formatNum(num) {
  if (num > 100000000) {
    return (num / 100000000).toFixed(0) + "亿";
  } else if (num > 10000) {
    if (num > 1000000) {
      return (num / 10000).toFixed(0) + "万";
    } else if (num > 100000) {
      return (num / 10000).toFixed(1) + "万";
    }
  }
  return num;
}

const toLiveRoom = (data) => {
  uitlsToLiveRoom(data, router)
};

const __returned__ = { t, route, router, data, livezb, getdata, formatNum, toLiveRoom, ToBack }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})